import React, { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { CSSTransition } from 'react-transition-group';
import './Overlay.css';

type OverlayProps = {
    wide?: boolean;
};

const Overlay: FC<PropsWithChildren<OverlayProps>> = ({ children, wide = false }) => {
    const nodeRef = useRef(null);
    const navigate = useNavigate();
    const [ isOpen, setIsOpen ] = useState(false);
    // Нельзя установить isOpen сразу в true т.к. в этом
    // случае CSSTransition не будет применять анимацию
    // появления
    useEffect(() => {
        setIsOpen(true);
    }, []);
    // Классы для широкой версии надо указывать именно в такой последовтаельности
    // иначе CSSTransition будет неверно добавлять классы анимации
	return (
        <CSSTransition
            in={isOpen}
            timeout={300}
            classNames={wide ? 'wide Overlay' : 'Overlay'}
            nodeRef={nodeRef}
            onExited={() => navigate('..')}
        >
            <div ref={nodeRef} className='Overlay'>
                <div className='Close' onClick={() => setIsOpen(false)}>
                    <Icon icon={faXmark} fixedWidth/>
                </div>
                {children}
            </div>
        </CSSTransition>
	);
};

export default Overlay;
